"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Api = (function () {
    function Api(apiUrl) {
        this.url = apiUrl;
    }
    Api.prototype.send = function (uri, json, successCallback, errorCallback) {
        $.ajax({
            url: this.url + uri,
            type: "post",
            data: json,
            success: function (response) {
                successCallback(response);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                errorCallback(jqXHR, textStatus, errorThrown);
            }
        });
    };
    return Api;
}());
exports.default = Api;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/api/api.ts
// module id = 1209
// module chunks = 0